let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iJ5yk")).then(() => parcelRequire('htWDI'));